<template>
  <nav class="ui blue inverted menu">
    <div class="logo item">
       <img src="../assets/logo_text_dark-background.svg" height="25" alt="" style="width: auto">
    </div>
    <a v-if="currentComponent === '' || currentComponent === 'timeline'" class="item active">Time-Line</a>
    <a v-if="currentComponent !== '' && currentComponent !== 'timeline'" @click="$emit('toggle-timeline')" class="item">Time-Line</a>
    <a v-if="currentComponent === 'tags'" class="item active">Tags</a>
    <a v-if="currentComponent !== 'tags'" @click="$emit('toggle-tags')" class="item">Tags</a>
    <a v-if="currentComponent === 'stats'" class="item active">Stats</a>
    <a v-if="currentComponent !== 'stats'" @click="$emit('toggle-stats')" class="item">Stats</a>
    <div class="item">
      <date-picker v-model="date" lang="de" :not-after="new Date()" format="DD.MM.YYYY" :first-day-of-week="1"></date-picker>
    </div>
    <a class="right item" @click="toggleSettings">
      <i class="settings icon"></i>
    </a>
  </nav>
</template>

<script>

import {EventBus} from '../eventBus.js';
import DatePicker from 'vue2-datepicker'

export default {
  name: 'MainNavigation',
  props: ['currentComponent', 'selectedDate'],
  components: {
    DatePicker
  },
  data: function() {
    return {
      date: new Date(),
      previousComponent: null
    }
  },
  methods: {
    toggleSettings: function () {
      if (this.currentComponent !== 'settings') {
        this.previousComponent = this.currentComponent;
        this.$emit('toggle-settings');
      } else if (this.previousComponent !== null) {
        this.$emit('toggle-' + this.previousComponent);
      }
    }
  },
  watch: {
      date: function(newValue) {
          if(newValue != null) {
            this.$emit('setSelectedDate', newValue);
            EventBus.$emit('selectDate', newValue);
          }
      }
  },
  created: function () {
      this.date = this.selectedDate;
  }
}
</script>

<style scoped>
  nav {
    border-radius: 0 !important;
    height: 50px;
  }
  nav .logo {
    padding: 5px;
    width: auto;
    height: 100%;
  }
  nav .logo img {
    width: auto;
    height: 100%;
    padding: 0;
  }
</style>
